import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Switch from "react-switch";
import { ToastContainer } from "react-toastify";

import { api } from "../services/index";

import Loading from "./Loading";
import Field from "./inputs/Field";
import Radio from "./inputs/Radio";
import Checkbox from "./inputs/Checkbox";
import TableFields from "./inputs/TableFields";

import { authUserData } from "../helpers";

import { onClickSaveSaqData } from "../modules/actions";
import { callApiSaqsGet } from "../services";
import loading from "../static/images/loading.gif";
import Header from "./Header";
import Label from "./inputs/Label";

class ComponentSaq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subdomain: "",
      saqId: null,
      page: 0,
      currentPageData: null,
      values: {},
      totalPages: 0,
      lastPageVisited: 0,
      notApplicable: [],
      showSimplifiedOptions: true,
      showTitle: true,
      processing: "no",
      businessId: null,
    };

    this.handleUnload = this.handleUnload.bind(this);
  }

  handleUnload(e) {
    var message = "o/";

    (e || window.event).returnValue = message; // Gecko + IE
    return message;
  }

  componentDidMount() {
    let hostData = window.location.host.split(".");

    /* if (hostData && hostData.length !== 3) {
      window.location.href = "http://saqgenerator.local";
    } */

    this.setState({
      subdomain: hostData[0],
    });

    window.scrollTo(0, 0);

    window.addEventListener("beforeunload", this.handleUnload);

    if (this.props.saqId) {
      callApiSaqsGet(this.props.saqId)
        .then((res) => {
          if (res && res.data && res.data.hasOwnProperty("saqAnswers")) {
            this.setState(
              {
                values: res.data.saqAnswers,
                lastPageVisited: res.data.lastPageVisited,
                page: res.data.lastPageVisited,
              },
              () => {
                this.updateCurrentPage(this.state.page);
              }
            );
          }
        })
        .catch((error) => {
          //console.log("Saq edit error...", error);
        });
    } else {
      this.updateCurrentPage(this.state.page);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleUnload);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.saqData && newProps.saqData.data) {
      this.setState({
        saqId: newProps.saqData.data._id,
      });
    }
  }

  updateCurrentPage = (page) => {
    const activePageData = this.props.formDataSaq[page];

    const activePageInputUids = activePageData.fields.reduce(
      (thisObject, field) => {
        if (field.component === "fieldGroup") {
          for (const subField of field.fields) {
            thisObject[subField._uid] = "";
          }
        } else if (field.component === "table") {
          for (const subField of field.fields) {
            if (subField.fields) {
              for (const innerSubField of subField.fields) {
                // console.log("innerSubField", innerSubField);
                if (
                  innerSubField.type !== "" &&
                  innerSubField.type !== "radio"
                ) {
                  thisObject[innerSubField._uid] = "";
                } else {
                  thisObject[innerSubField._uid] =
                    (innerSubField &&
                      innerSubField.hasOwnProperty("value") &&
                      innerSubField.value) ||
                    "no";
                }
              }
            } else {
              if (thisObject.type !== "") {
                thisObject[subField._uid] = "";
              }
            }
          }
        } else {
          if (thisObject.type !== "") {
            thisObject[field._uid] = "";
          }
        }

        return thisObject;
      },
      {}
    );

    this.setState(
      {
        currentPageData: this.props.formDataSaq[page],
        totalPages: this.props.formDataSaq.length,
        values: Object.assign({}, activePageInputUids, this.state.values),
      },
      () => {
        //console.log("Page changed.");
        window.scrollTo(0, 0);
      }
    );
  };

  fieldMeetsCondition = (values) => (field) => {
    // console.log("fieldMeetsCondition");
    if (field.conditional && field.conditional.field) {
      //console.log("IF field._uid", field._uid);
      //console.log(values[field._uid]);
      const segments = field.conditional.field.split("_");

      const fieldId = segments[segments.length - 1];
      return values[fieldId] === field.conditional.value;
    }

    return true;
  };

  handleFieldChanged = (fieldId, value, resetFields = null) => {
    // console.log("123 fieldId", fieldId);
    //console.log("value", value);
    let resetStatus = false;

    this.setState((prevState) => ({
      values: {
        // Object that we want to update
        ...prevState.values, // Keep all other key-value pairs
        [fieldId]: value, // Update the value of specific key
      },
      currentPageData: { ...prevState.currentPageData },
    }));

    if (resetFields) {
      // console.log("resetFields", resetFields);

      if (
        resetFields.value &&
        resetFields.value.length > 0 &&
        resetFields.value.includes(value)
      ) {
        //console.log(11);
        resetStatus = true;
      } else if (resetFields.value === value) {
        // console.log(22);
        resetStatus = true;
      }

      if (resetStatus === true) {
        resetFields._uids.map((v, i) => {
          //console.log("v", v);
          //console.log(this.state.values[v]);

          this.setState((prevState) => ({
            values: {
              // Object that we want to update
              ...prevState.values, // Keep all other key-value pairs
              [v]: "", // Update the value of specific key
            },
            currentPageData: { ...prevState.currentPageData },
          }));
        });
      }
    }
  };

  handlePrefillOptions = (type, value) => {
    // console.log(111111, type);
    // console.log(value);
    let uids;

    switch (type) {
      case "A":
        uids = [
          "2ced54de-5b80-4f48-8f4b-4e4e72861154",
          "e23446ac-19c4-400a-b0c2-4db5aabf4883",
          "6bba1b81-d646-4b99-9b48-be90fd1e5123",
          "ec674070-83a0-4b78-bba5-81e3181a98db",
          "4d7772bb-b114-4f5d-8a59-7a10522f9edb",
          "f924b88d-68af-4408-bcb3-c172f281d11b",
          "0bd82c76-f93d-46ba-9387-7b82a21783fc",
          "f2c103a1-a8a9-49e4-933e-e0c770ac4b38",
          "697b2020-5b53-41ad-8833-10ca32041cc7",
          "d0c21492-395c-4ebc-906a-90aa3b4751df",
          "9590a764-ff2d-40c2-a416-6a2b1927808e",
          "c24e59ab-bd97-41f3-b931-8f67fd77ed20",
          "32b9e151-ac03-405e-b1b7-3ac1593c64cc",
          "69868741-8916-44b5-987d-ff409346bbc6",
          "b3247b69-da29-4cfe-82f9-af09212d724f",
          "c04e9d48-f2e3-4667-b836-d76b09697fb1",
          "99cc17e4-17d7-4109-becc-9064d032bd9b",
          "ccb7da28-a7dc-4d17-afca-538b5a2623d6",
          "e719cb38-b7e2-4ba4-9fcf-d6fe507d6ce4",
          "dd7593a7-d618-429a-b464-025e2535c248",
          "948511ec-2a1e-45c1-b976-a3cce9f2c9f3",
          "b23f3713-d931-41dc-a567-d0138d9850f7",
          "e2d203c9-1b3b-4f9c-9b94-0e0fefb53642",
          "36b4ac54-08d6-4c41-8a8d-02ef8e554c8e",
          "2b9c301c-7eb6-4af7-a60c-b52aa088adea",
          "5c59e570-80fb-4a90-8c43-00733f977ec6",
          "b1d4ffa6-36c6-4e8e-a90d-220c526ee61b",
          "6513c7da-3894-4c92-ba89-bf75834c1b21",
          "63fff20d-a022-42b9-8c16-bfec89f01384",
          "c33690f2-0813-4a47-80f3-bc1fc453cb67",
          "384945ff-bca6-4ca0-948c-6168ceefda51",
          "686e307f-e890-4567-8c1c-b945bdfd80f5",
          "854f7ce6-3090-466c-ae10-9fdf2a4bd70f",
        ];
        uids.map((v, i) => {
          this.setState((prevState) => ({
            values: {
              // Object that we want to update
              ...prevState.values, // Keep all other key-value pairs
              [v]: value, // Update the value of specific key
            },
            currentPageData: { ...prevState.currentPageData },
          }));
        });
        break;
      case "A-EP":
        uids = [
          "d742abf0-34cf-4c07-9133-2656503b848d",
          "f7b97316-ceef-4585-85a9-15b0001fef79",
          "a07f4f45-a5fe-4b4b-b792-3d635ffc96cf",
          "04d61978-28a7-47be-9176-a17005adec19",
          "86301a0b-152a-46d8-a244-9a98d21a6c7a",
          "cdaa3646-53db-4ae4-81e3-e23e8058442b",
          "464b0d71-f6e0-4dbf-94c0-e00d427d61ba",
          "f768dc52-fe1b-4323-824c-bdd036e097ab",
          "cafa9075-4b2a-4275-97ee-3754b5f8405c",
          "4678fed8-63e6-4034-9ddf-8328ee39723d",
          "1c53e5dd-477e-41a4-bc53-faaa0766eda2",
          "699249cb-f9c4-4740-9ad4-bfcbcff91201",
          "1b20dee1-39f7-427b-8bb4-82d425fcdfe3",
          "8f5e2c2d-3dfd-4f02-a1f4-bf04df7c229c",
          "98933a66-cd0f-4567-98e6-7c0b77fd6c6c",
          "c6c9f11e-95f4-4d8e-a529-08ba12410ea0",
          "08fb6e01-4b0c-4a76-8a73-ac6fa1f825a5",
          "3d450785-a99a-4a85-93d3-5f4e5c41a78a",
          "ddfb1986-af32-4a94-a729-b0573b86c7ae",
          "2b45c9c6-41fe-44cc-aa62-ef9bb8067781",
          "2ced54de-5b80-4f48-8f4b-4e4e72861154",
          "640e46ca-d2d5-4a17-9555-390ef9cdbe49",
          "e43637ef-202c-42f9-b11d-bbfb35f7b064",
          "101bec8b-e69c-4d83-850f-26ab9c73e428",
          "dee26b3c-b40b-4049-a59f-ee4fa8ce96d0",
          "cba3a8cd-1c4b-4c82-a3b0-cab2693b025a",
          "e23446ac-19c4-400a-b0c2-4db5aabf4883",
          "6bba1b81-d646-4b99-9b48-be90fd1e5123",
          "884a2baa-c99e-4314-9197-34b8f13fb120",
          "bbcb5406-b3b0-44f2-bc67-f05e64ba8080",
          "4433a0e5-0224-44b7-8285-18dcf1eeebe0",
          "d6b563de-d276-44c8-a093-fb73a928dd9a",
          "6977ca94-a321-42b6-a181-754e9842c3e9",
          "ac1fc75d-dccf-4988-9529-1f9836a0c53d",
          "e413cf69-a333-454e-abea-53e7de37dd1d",
          "6c6f9fff-7f23-4f0e-a3e7-4645436eff8d",
          "d28e1f71-f3e4-491f-ad1d-2df0501cf631",
          "634bb0b1-4ea5-4fb0-9c4f-bac730b5d22a",
          "edc64438-0429-4499-abeb-6e19b94d1630",
          "f4d6e6de-8740-49b6-8890-1030b0d83094",
          "a049b982-8a08-4513-94b3-e02050ece2a8",
          "3114324c-32b1-444a-9e9f-a9cb2f644eb4",
          "8a2e8b27-ef43-460f-b9a0-e05e36109f82",
          "a8f8af09-efc3-4c31-a1fe-a258e03ba596",
          "b54150bc-ff5c-4a4e-89ed-e464738c8fe1",
          "ed428593-9b0d-4bfb-a0a3-bfdb1f07b867",
          "1078d1eb-8b26-43e6-8a7c-f50baace4493",
          "52b8d052-eb27-45ef-937b-4d805624e1d8",
          "7ba3c36e-fe1d-4a1c-b128-4ef28914e3b1",
          "ec674070-83a0-4b78-bba5-81e3181a98db",
          "18fb448b-e1e3-4609-b2c8-4ddb03ffbaec",
          "f88b4e60-1b70-41e2-a093-ad6b56b0b2c7",
          "e4bd43f0-523e-4aca-b763-abd0d4452765",
          "f742e5ee-866c-4ecc-853b-5bb7a3aa8e0e",
          "e1d90790-67b0-4cf8-a1b0-adc93af5dd11",
          "5734f093-fe98-433c-8f55-381d77d2e914",
          "b1376447-ec2c-467f-bdf3-213ff8d87e88",
          "81293d49-5af5-4f63-9986-3f05286030a4",
          "0d0c3531-eb15-43b7-950b-4d638136c650",
          "58ab2b79-62cf-45ca-993c-51a301a1696f",
          "4d7772bb-b114-4f5d-8a59-7a10522f9edb",
          "66217eb7-4aec-4fed-b0b8-b7f204a4cdbf",
          "ae90f1cd-6033-40c5-8aa2-3b04720712fc",
          "f9af4847-2f17-4b20-8e36-6a38e0e8858f",
          "f924b88d-68af-4408-bcb3-c172f281d11b",
          "0bd82c76-f93d-46ba-9387-7b82a21783fc",
          "f2c103a1-a8a9-49e4-933e-e0c770ac4b38",
          "32eb36ba-7fc1-498a-89bd-9a57e089ea28",
          "0404379c-9953-4bd2-a753-104cb6956a91",
          "ff63fbeb-db1c-4325-baca-3a8432dbe7b7",
          "37b133a1-e6ba-4808-987a-9a709354e4a3",
          "d9784db8-2699-4408-9d11-94dd8f4950e0",
          "509cf493-4e2c-464d-89f5-94aa8ff7536e",
          "c46eba6c-442d-4889-be80-948496820222",
          "697b2020-5b53-41ad-8833-10ca32041cc7",
          "d0c21492-395c-4ebc-906a-90aa3b4751df",
          "010f5e3b-71ed-404d-9dc7-661104068560",
          "9590a764-ff2d-40c2-a416-6a2b1927808e",
          "c8e5bac5-df1f-45b5-ba4e-50fff1161c14",
          "e0d026f0-88af-4b64-8358-c1cb103602ea",
          "3969900b-7498-45ae-a67b-a42fee1f3357",
          "c24e59ab-bd97-41f3-b931-8f67fd77ed20",
          "1e64147e-8248-4431-b987-6b43c0a87b72",
          "aceb2cf5-7241-45af-925f-33e038def041",
          "a9c7f4f1-ef9c-416a-9976-72e028628074",
          "32b9e151-ac03-405e-b1b7-3ac1593c64cc",
          "69868741-8916-44b5-987d-ff409346bbc6",
          "b3247b69-da29-4cfe-82f9-af09212d724f",
          "f381e3ab-d51d-4cd5-88e2-2fb251a767ea",
          "c04e9d48-f2e3-4667-b836-d76b09697fb1",
          "f87c6061-240b-4f33-afa5-730d71805c3d",
          "9d22302f-75d3-48e1-aad6-1449c30c6ba8",
          "c444739f-b439-42b8-8d1a-cec6de08badc",
          "2dbbaf98-0f34-479c-a150-be4f75a95a35",
          "e7908971-3a76-4188-93ef-fc2b10b17ab8",
          "6f15115f-c352-4f9f-a1e7-30be29367fec",
          "1268a0cf-cef2-43db-9ee7-61059ae1b579",
          "56867429-4f9c-4ac3-9612-d8e4690441a6",
          "3d9893fc-fa09-4ac4-b178-e1099bce48f1",
          "99cc17e4-17d7-4109-becc-9064d032bd9b",
          "ccb7da28-a7dc-4d17-afca-538b5a2623d6",
          "e719cb38-b7e2-4ba4-9fcf-d6fe507d6ce4",
          "dd7593a7-d618-429a-b464-025e2535c248",
          "948511ec-2a1e-45c1-b976-a3cce9f2c9f3",
          "b23f3713-d931-41dc-a567-d0138d9850f7",
          "6f49fdbb-ad9f-4d7a-ae40-2f1a61c2c947",
          "ef2ef2c5-8c56-4c57-a84e-3b173231456f",
          "0924deaa-c9e0-43d1-9629-284bcabb556d",
          "1009d3b1-ab5c-419e-8ed7-427c6d66e08a",
          "af2dc40d-9bff-4941-b487-21efcd512176",
          "e25036e0-9f23-407e-aacd-b3cb14a13b90",
          "b550c9dd-ea05-4b09-8c88-47f071239f59",
          "8d750507-de52-41f2-b88a-b001c12cf008",
          "0989a337-8e20-4704-b727-a45c44c2a9f3",
          "2b114170-0532-4a0a-90e6-ae6a8f652b0d",
          "e90db5e6-004f-44c9-a10c-f1f8546f78c1",
          "5ac8d604-b11c-4106-b3df-f2bcc32f8c1a",
          "577eb8b3-4785-4de3-8873-458c81bedea6",
          "95efcd76-f7d7-45b2-b2cd-fc26b6a370a7",
          "a8121f0b-fcce-4b32-98f1-83b7cca5f5d5",
          "1b1cd8ef-34cc-4abd-8bfc-bc00150c7424",
          "abc72c86-8f45-43ed-9391-2b139ade85a8",
          "af84ab2d-5d17-4aee-9026-0ec1cf7d7d2b",
          "1d1b4acd-fd8e-4851-8646-6f7b6f123973",
          "23f6546f-4be5-47bd-b8df-694da76df679",
          "2c0a4a78-54fd-4720-b9b4-463b13219f9c",
          "41bc93a6-1d29-4ccb-b19a-9999803dc362",
          "e2d203c9-1b3b-4f9c-9b94-0e0fefb53642",
          "36b4ac54-08d6-4c41-8a8d-02ef8e554c8e",
          "1dd8a169-83d4-401b-966f-1912160d7760",
          "7a389de3-093c-49c5-99a4-83008ed6584e",
          "fc9a0b7c-a314-462c-8215-35885a399dc4",
          "b06a9af6-6718-49a3-8e57-9d5ce1578b59",
          "1a3c2eda-e41d-4ceb-8f56-cc50da8c117e",
          "c1258e5f-ce0f-4285-8cca-15ea685ab432",
          "2b9c301c-7eb6-4af7-a60c-b52aa088adea",
          "5c59e570-80fb-4a90-8c43-00733f977ec6",
          "b1d4ffa6-36c6-4e8e-a90d-220c526ee61b",
          "55903b10-e7da-4d62-b274-02c9818868ea",
          "8341e3bc-9f2f-4fef-910a-284f63611735",
          "4ea0321a-a184-4484-9210-3e3dab854b3d",
          "a2f3e53c-aef6-4f8e-8d1c-b9dfd514ef09",
          "ffca3e33-de1d-441c-adc6-c8fa4821205f",
          "6c4632ed-6148-4812-a77a-88a2bda3c51c",
          "ebe3785c-2511-472c-9bbe-e666e3ff4165",
          "6513c7da-3894-4c92-ba89-bf75834c1b21",
          "63fff20d-a022-42b9-8c16-bfec89f01384",
          "c33690f2-0813-4a47-80f3-bc1fc453cb67",
          "384945ff-bca6-4ca0-948c-6168ceefda51",
          "686e307f-e890-4567-8c1c-b945bdfd80f5",
          "854f7ce6-3090-466c-ae10-9fdf2a4bd70f",
          "bbd3ab16-680b-4614-8e42-570fcc6ac9a5",
        ];
        uids.map((v, i) => {
          this.setState((prevState) => ({
            values: {
              // Object that we want to update
              ...prevState.values, // Keep all other key-value pairs
              [v]: value, // Update the value of specific key
            },
            currentPageData: { ...prevState.currentPageData },
          }));
        });
        break;
      case "B":
        uids = [
          "e23446ac-19c4-400a-b0c2-4db5aabf4883",
          "884a2baa-c99e-4314-9197-34b8f13fb120",
          "c0c677a5-77d9-4980-a55c-a79378859195",
          "bbcb5406-b3b0-44f2-bc67-f05e64ba8080",
          "feed0952-27ef-41ba-b2f1-9158b2b5a0fc",
          "e50e1d62-77b3-4a10-acc9-c757a70394dc",
          "9ea42253-9833-4964-80c3-c04c0e36aef1",
          "385b10b0-4424-4a71-9846-688a501716ad",
          "6cfca733-fd59-465b-ba0f-86549b3220e7",
          "8fa12b9e-7ace-4423-b4a3-c6e2f3cd99cd",
          "2acf72fe-8881-4f93-8b62-c5acfb53ffe2",
          "dfe6ec31-a754-4c39-9cbc-cf030693d86d",
          "da2ce266-0409-4361-97c7-0231f729d75e",
          "d34243f0-167c-44a2-bbb0-ff94ddfcc23b",
          "e3994cdd-8ae0-484d-9268-263d3a3fa7ef",
          "6020abb3-c51c-4d09-8968-415b5681eb59",
          "5409ac7e-93db-45b1-aa80-5c98807e051e",
          "8eb94fd6-20ce-4519-ab04-213cc3efce32",
          "bfb04652-66eb-4057-b1fc-0fa508922135",
          "7ed9c184-b79b-4371-a9bc-dbfa0122f30c",
          "b70a1c21-98dd-4bba-8242-f5d35ca986a2",
          "409155bb-1597-43c2-ba36-f3d6b94139fa",
          "9e55ca08-ec3e-4b24-8446-2da83da984fd",
          "d5840692-355c-4878-87fe-86c225868493",
          "74b33313-eff5-4e21-ac48-86fe53e970fb",
          "e8b661c5-9d09-4610-be60-deecbac37a7d",
          "0c320f6a-137e-44aa-854c-8716d209dff8",
        ];
        uids.map((v, i) => {
          this.setState((prevState) => ({
            values: {
              // Object that we want to update
              ...prevState.values, // Keep all other key-value pairs
              [v]: value, // Update the value of specific key
            },
            currentPageData: { ...prevState.currentPageData },
          }));
        });
      case "B-IP":
        uids = [
          "7fc6ae4f-8b48-4c17-ab8d-07b8088e8182",
          "fe565243-5504-4070-b1ec-488a1427fd76",
          "24e0374e-c223-452d-b4ae-43e6875d96a2",
          "d9784db8-2699-4408-9d11-94dd8f4950e0",
          "1e64147e-8248-4431-b987-6b43c0a87b72",
          "aceb2cf5-7241-45af-925f-33e038def041",
          "5a50b406-1ef4-429d-b43c-85cead898f30",
          "6b276bf9-a51f-4a1f-bfc7-416f9317aeda",
          "0c26c53c-23aa-4ecb-b0e2-ae34228e4ac6",
          "c362c8ad-8c01-4d58-890c-3acfebe21bda",
          "10c7b9e2-d95d-4957-99b4-179a6cbe29fe",
          "e23446ac-19c4-400a-b0c2-4db5aabf4883",
          "884a2baa-c99e-4314-9197-34b8f13fb120",
          "c0c677a5-77d9-4980-a55c-a79378859195",
          "bbcb5406-b3b0-44f2-bc67-f05e64ba8080",
          "feed0952-27ef-41ba-b2f1-9158b2b5a0fc",
          "e50e1d62-77b3-4a10-acc9-c757a70394dc",
          "8341e3bc-9f2f-4fef-910a-284f63611735",
          "c45f1b0a-6fc7-4bcb-bbeb-a5ab610deb02",
          "9ea42253-9833-4964-80c3-c04c0e36aef1",
          "1f015770-ae73-4e3e-b231-749d4a89d94d",
          "0fc56d9e-03e6-4feb-8220-2c060e323657",
          "63a23a79-ce4b-4a06-aad9-4a5107f56a92",
          "1c2adfca-51da-4c84-aae8-4ce7bf76a381",
          "43c4a6fc-d894-4ed8-aabd-0c8790d6c078",
          "da3af7a7-3f56-4ef3-8d7d-47a757e049dc",
          "385b10b0-4424-4a71-9846-688a501716ad",
          "6cfca733-fd59-465b-ba0f-86549b3220e7",
          "8fa12b9e-7ace-4423-b4a3-c6e2f3cd99cd",
          "2acf72fe-8881-4f93-8b62-c5acfb53ffe2",
          "dfe6ec31-a754-4c39-9cbc-cf030693d86d",
          "da2ce266-0409-4361-97c7-0231f729d75e",
          "d34243f0-167c-44a2-bbb0-ff94ddfcc23b",
          "e3994cdd-8ae0-484d-9268-263d3a3fa7ef",
          "6020abb3-c51c-4d09-8968-415b5681eb59",
          "5409ac7e-93db-45b1-aa80-5c98807e051e",
          "96b8eb3f-59ca-442b-8bd9-2ebeb9f72a9a",
          "9f7bfbea-c236-4a45-bb82-bdd5992db13d",
          "8eb94fd6-20ce-4519-ab04-213cc3efce32",
          "bfb04652-66eb-4057-b1fc-0fa508922135",
          "7ed9c184-b79b-4371-a9bc-dbfa0122f30c",
          "b70a1c21-98dd-4bba-8242-f5d35ca986a2",
          "409155bb-1597-43c2-ba36-f3d6b94139fa",
          "9e55ca08-ec3e-4b24-8446-2da83da984fd",
          "d5840692-355c-4878-87fe-86c225868493",
          "74b33313-eff5-4e21-ac48-86fe53e970fb",
          "e8b661c5-9d09-4610-be60-deecbac37a7d",
          "0c320f6a-137e-44aa-854c-8716d209dff8",
          "db51907a-e243-4d79-ab61-602425ac64b3",
        ];
        uids.map((v, i) => {
          this.setState((prevState) => ({
            values: {
              // Object that we want to update
              ...prevState.values, // Keep all other key-value pairs
              [v]: value, // Update the value of specific key
            },
            currentPageData: { ...prevState.currentPageData },
          }));
        });
      case "C":
        uids = [
          "4678fed8-63e6-4034-9ddf-8328ee39723d",
          "1c53e5dd-477e-41a4-bc53-faaa0766eda2",
          "699249cb-f9c4-4740-9ad4-bfcbcff91201",
          "ddfb1986-af32-4a94-a729-b0573b86c7ae",
          "2b45c9c6-41fe-44cc-aa62-ef9bb8067781",
          "2ced54de-5b80-4f48-8f4b-4e4e72861154",
          "640e46ca-d2d5-4a17-9555-390ef9cdbe49",
          "e43637ef-202c-42f9-b11d-bbfb35f7b064",
          "101bec8b-e69c-4d83-850f-26ab9c73e428",
          "dee26b3c-b40b-4049-a59f-ee4fa8ce96d0",
          "cba3a8cd-1c4b-4c82-a3b0-cab2693b025a",
          "1a1bfa4b-5f0a-4534-bb00-13abb8f62b93",
          "8a7c019a-5b68-48c9-975f-7d2299ca9254",
          "e23446ac-19c4-400a-b0c2-4db5aabf4883",
          "884a2baa-c99e-4314-9197-34b8f13fb120",
          "bbcb5406-b3b0-44f2-bc67-f05e64ba8080",
          "4433a0e5-0224-44b7-8285-18dcf1eeebe0",
          "7897dd44-388e-4287-969a-c59e20b21924",
          "6977ca94-a321-42b6-a181-754e9842c3e9",
          "ac1fc75d-dccf-4988-9529-1f9836a0c53d",
          "e413cf69-a333-454e-abea-53e7de37dd1d",
          "6c6f9fff-7f23-4f0e-a3e7-4645436eff8d",
          "a6415f4a-9381-437f-a828-73bd56184d39",
          "d28e1f71-f3e4-491f-ad1d-2df0501cf631",
          "634bb0b1-4ea5-4fb0-9c4f-bac730b5d22a",
          "edc64438-0429-4499-abeb-6e19b94d1630",
          "f4d6e6de-8740-49b6-8890-1030b0d83094",
          "a049b982-8a08-4513-94b3-e02050ece2a8",
          "3114324c-32b1-444a-9e9f-a9cb2f644eb4",
          "8a2e8b27-ef43-460f-b9a0-e05e36109f82",
          "a8f8af09-efc3-4c31-a1fe-a258e03ba596",
          "b54150bc-ff5c-4a4e-89ed-e464738c8fe1",
          "ed428593-9b0d-4bfb-a0a3-bfdb1f07b867",
          "1078d1eb-8b26-43e6-8a7c-f50baace4493",
          "52b8d052-eb27-45ef-937b-4d805624e1d8",
          "7ba3c36e-fe1d-4a1c-b128-4ef28914e3b1",
          "18fb448b-e1e3-4609-b2c8-4ddb03ffbaec",
          "f88b4e60-1b70-41e2-a093-ad6b56b0b2c7",
          "7ba9c223-de24-4a6d-b3f9-565e1356adcf",
          "e4bd43f0-523e-4aca-b763-abd0d4452765",
          "f742e5ee-866c-4ecc-853b-5bb7a3aa8e0e",
          "e1d90790-67b0-4cf8-a1b0-adc93af5dd11",
          "5734f093-fe98-433c-8f55-381d77d2e914",
          "b1376447-ec2c-467f-bdf3-213ff8d87e88",
          "81293d49-5af5-4f63-9986-3f05286030a4",
          "0d0c3531-eb15-43b7-950b-4d638136c650",
          "4d7772bb-b114-4f5d-8a59-7a10522f9edb",
          "32eb36ba-7fc1-498a-89bd-9a57e089ea28",
          "0404379c-9953-4bd2-a753-104cb6956a91",
          "ff63fbeb-db1c-4325-baca-3a8432dbe7b7",
          "37b133a1-e6ba-4808-987a-9a709354e4a3",
          "d9784db8-2699-4408-9d11-94dd8f4950e0",
          "509cf493-4e2c-464d-89f5-94aa8ff7536e",
          "c46eba6c-442d-4889-be80-948496820222",
          "697b2020-5b53-41ad-8833-10ca32041cc7",
          "d0c21492-395c-4ebc-906a-90aa3b4751df",
          "010f5e3b-71ed-404d-9dc7-661104068560",
          "9590a764-ff2d-40c2-a416-6a2b1927808e",
          "c8e5bac5-df1f-45b5-ba4e-50fff1161c14",
          "e0d026f0-88af-4b64-8358-c1cb103602ea",
          "3969900b-7498-45ae-a67b-a42fee1f3357",
          "c24e59ab-bd97-41f3-b931-8f67fd77ed20",
          "1e64147e-8248-4431-b987-6b43c0a87b72",
          "aceb2cf5-7241-45af-925f-33e038def041",
          "a9c7f4f1-ef9c-416a-9976-72e028628074",
          "32b9e151-ac03-405e-b1b7-3ac1593c64cc",
          "69868741-8916-44b5-987d-ff409346bbc6",
          "b3247b69-da29-4cfe-82f9-af09212d724f",
          "f381e3ab-d51d-4cd5-88e2-2fb251a767ea",
          "c04e9d48-f2e3-4667-b836-d76b09697fb1",
          "9d22302f-75d3-48e1-aad6-1449c30c6ba8",
          "c444739f-b439-42b8-8d1a-cec6de08badc",
          "2dbbaf98-0f34-479c-a150-be4f75a95a35",
          "e7908971-3a76-4188-93ef-fc2b10b17ab8",
          "6f15115f-c352-4f9f-a1e7-30be29367fec",
          "1268a0cf-cef2-43db-9ee7-61059ae1b579",
          "56867429-4f9c-4ac3-9612-d8e4690441a6",
          "243e3d46-9aff-4b8b-bb52-4026204038b7",
          "3d9893fc-fa09-4ac4-b178-e1099bce48f1",
          "e98ceedd-20ca-473b-b815-a2f448e79c99",
          "d73b8a97-5d86-4d97-950d-8f2ade1e6fdb",
          "99cc17e4-17d7-4109-becc-9064d032bd9b",
          "ccb7da28-a7dc-4d17-afca-538b5a2623d6",
          "e719cb38-b7e2-4ba4-9fcf-d6fe507d6ce4",
          "dd7593a7-d618-429a-b464-025e2535c248",
          "948511ec-2a1e-45c1-b976-a3cce9f2c9f3",
          "b23f3713-d931-41dc-a567-d0138d9850f7",
          "c0076a59-585a-46a2-a716-dca7afe832d9",
          "97495965-1f0d-403e-8105-d1bb414d5d4c",
          "0d82b1eb-2d9a-458f-930b-a8f6573484c8",
          "8c2a9724-e048-41f1-96dc-0d54756726f6",
          "6f49fdbb-ad9f-4d7a-ae40-2f1a61c2c947",
          "0924deaa-c9e0-43d1-9629-284bcabb556d",
          "af2dc40d-9bff-4941-b487-21efcd512176",
          "e25036e0-9f23-407e-aacd-b3cb14a13b90",
          "0989a337-8e20-4704-b727-a45c44c2a9f3",
          "2b114170-0532-4a0a-90e6-ae6a8f652b0d",
          "e90db5e6-004f-44c9-a10c-f1f8546f78c1",
          "5ac8d604-b11c-4106-b3df-f2bcc32f8c1a",
          "577eb8b3-4785-4de3-8873-458c81bedea6",
          "95efcd76-f7d7-45b2-b2cd-fc26b6a370a7",
          "a8121f0b-fcce-4b32-98f1-83b7cca5f5d5",
          "1b1cd8ef-34cc-4abd-8bfc-bc00150c7424",
          "abc72c86-8f45-43ed-9391-2b139ade85a8",
          "af84ab2d-5d17-4aee-9026-0ec1cf7d7d2b",
          "1d1b4acd-fd8e-4851-8646-6f7b6f123973",
          "23f6546f-4be5-47bd-b8df-694da76df679",
          "2c0a4a78-54fd-4720-b9b4-463b13219f9c",
          "41bc93a6-1d29-4ccb-b19a-9999803dc362",
          "dba398e2-396a-4dbe-b373-52e791412d62",
          "a70d4ce5-9cdd-4543-80ec-b7f8403b6ac6",
          "76e4a34a-50ed-43e7-a0bc-8ba848261abb",
          "47ec580f-b2c3-4e38-a73e-0ab534bf317e",
          "e2d203c9-1b3b-4f9c-9b94-0e0fefb53642",
          "36b4ac54-08d6-4c41-8a8d-02ef8e554c8e",
          "b06a9af6-6718-49a3-8e57-9d5ce1578b59",
          "c1258e5f-ce0f-4285-8cca-15ea685ab432",
          "55903b10-e7da-4d62-b274-02c9818868ea",
          "8341e3bc-9f2f-4fef-910a-284f63611735",
          "4ea0321a-a184-4484-9210-3e3dab854b3d",
          "a2f3e53c-aef6-4f8e-8d1c-b9dfd514ef09",
          "ffca3e33-de1d-441c-adc6-c8fa4821205f",
          "6c4632ed-6148-4812-a77a-88a2bda3c51c",
          "ebe3785c-2511-472c-9bbe-e666e3ff4165",
          "6513c7da-3894-4c92-ba89-bf75834c1b21",
          "63fff20d-a022-42b9-8c16-bfec89f01384",
          "c33690f2-0813-4a47-80f3-bc1fc453cb67",
          "384945ff-bca6-4ca0-948c-6168ceefda51",
          "686e307f-e890-4567-8c1c-b945bdfd80f5",
          "854f7ce6-3090-466c-ae10-9fdf2a4bd70f",
          "bbd3ab16-680b-4614-8e42-570fcc6ac9a5",
          "98448179-791f-40be-bc4c-6f75ae3b37e3",
        ];
        uids.map((v, i) => {
          this.setState((prevState) => ({
            values: {
              // Object that we want to update
              ...prevState.values, // Keep all other key-value pairs
              [v]: value, // Update the value of specific key
            },
            currentPageData: { ...prevState.currentPageData },
          }));
        });
        break;
      case "D-ME":
        uids = [
          "d742abf0-34cf-4c07-9133-2656503b848d",
          "b743e9ec-55f5-4b06-b70e-9f08b77350c8",
          "f7b97316-ceef-4585-85a9-15b0001fef79",
          "a07f4f45-a5fe-4b4b-b792-3d635ffc96cf",
          "04d61978-28a7-47be-9176-a17005adec19",
          "86301a0b-152a-46d8-a244-9a98d21a6c7a",
          "cdaa3646-53db-4ae4-81e3-e23e8058442b",
          "464b0d71-f6e0-4dbf-94c0-e00d427d61ba",
          "f768dc52-fe1b-4323-824c-bdd036e097ab",
          "cafa9075-4b2a-4275-97ee-3754b5f8405c",
          "4678fed8-63e6-4034-9ddf-8328ee39723d",
          "1c53e5dd-477e-41a4-bc53-faaa0766eda2",
          "699249cb-f9c4-4740-9ad4-bfcbcff91201",
          "1b20dee1-39f7-427b-8bb4-82d425fcdfe3",
          "8f5e2c2d-3dfd-4f02-a1f4-bf04df7c229c",
          "98933a66-cd0f-4567-98e6-7c0b77fd6c6c",
          "c6c9f11e-95f4-4d8e-a529-08ba12410ea0",
          "08fb6e01-4b0c-4a76-8a73-ac6fa1f825a5",
          "3d450785-a99a-4a85-93d3-5f4e5c41a78a",
          "ddfb1986-af32-4a94-a729-b0573b86c7ae",
          "1a99c4ce-c1ff-4799-a68d-1d4b2560dc67",
          "2b45c9c6-41fe-44cc-aa62-ef9bb8067781",
          "2ced54de-5b80-4f48-8f4b-4e4e72861154",
          "640e46ca-d2d5-4a17-9555-390ef9cdbe49",
          "e43637ef-202c-42f9-b11d-bbfb35f7b064",
          "101bec8b-e69c-4d83-850f-26ab9c73e428",
          "dee26b3c-b40b-4049-a59f-ee4fa8ce96d0",
          "cba3a8cd-1c4b-4c82-a3b0-cab2693b025a",
          "1a1bfa4b-5f0a-4534-bb00-13abb8f62b93",
          "8a7c019a-5b68-48c9-975f-7d2299ca9254",
          "e23446ac-19c4-400a-b0c2-4db5aabf4883",
          "ce60acb8-b929-4300-92c0-870cc42e9212",
          "6bba1b81-d646-4b99-9b48-be90fd1e5123",
          "884a2baa-c99e-4314-9197-34b8f13fb120",
          "fc9809f2-2e5e-4cbe-b030-f33c0f119b13",
          "bbcb5406-b3b0-44f2-bc67-f05e64ba8080",
          "4433a0e5-0224-44b7-8285-18dcf1eeebe0",
          "5571db8d-ccd8-4779-bdd2-e4c9258da06d",
          "7897dd44-388e-4287-969a-c59e20b21924",
          "a2556df3-fcaa-427e-b2fe-1cffe848b5e9",
          "a6e7d090-312c-4c61-aca9-c579f821b2b9",
          "afa03869-eb23-4bf3-9529-887363dfc4be",
          "f97613b2-8f16-4540-9e7c-9f838fa8f101",
          "d2cf5099-338a-4a27-86d9-9c5c1b3b2629",
          "6bad95d1-3448-4f4a-a856-79c7e877cbf1",
          "5153e0d1-8029-4e0d-bac5-57f2dbae6b1b",
          "90bcfe57-96d1-4f13-bca6-226d566fa07e",
          "a25b46b7-0ba8-4e87-8732-ce43999a63a6",
          "b6dbfdff-0a0d-4be1-af5e-e23517b5a9ce",
          "20c228c7-697e-47d1-b890-7aee23c60a51",
          "4248ad28-642d-4f76-91a2-ea5e6a0a786c",
          "e2e22e75-895b-4708-aca1-893ceecb494a",
          "9c70de8d-6e5b-478d-8da4-43df88403553",
          "975a26f8-d5a1-40a9-bd59-4d18b48b5f2e",
          "e974fe74-e2df-4512-a5be-fa0ebebc7a3f",
          "e9c5afea-9545-4446-b04b-06d7ba756a23",
          "d6b563de-d276-44c8-a093-fb73a928dd9a",
          "01096367-35a8-4c6d-9ea6-a51b4772d7f2",
          "6977ca94-a321-42b6-a181-754e9842c3e9",
          "ac1fc75d-dccf-4988-9529-1f9836a0c53d",
          "e413cf69-a333-454e-abea-53e7de37dd1d",
          "6c6f9fff-7f23-4f0e-a3e7-4645436eff8d",
          "d12a8b31-4b5f-4407-b08b-4e4891f1c624",
          "a6415f4a-9381-437f-a828-73bd56184d39",
          "d28e1f71-f3e4-491f-ad1d-2df0501cf631",
          "634bb0b1-4ea5-4fb0-9c4f-bac730b5d22a",
          "143743ac-a356-44fc-8a5d-eab58a753860",
          "edc64438-0429-4499-abeb-6e19b94d1630",
          "f4d6e6de-8740-49b6-8890-1030b0d83094",
          "a049b982-8a08-4513-94b3-e02050ece2a8",
          "3114324c-32b1-444a-9e9f-a9cb2f644eb4",
          "8a2e8b27-ef43-460f-b9a0-e05e36109f82",
          "a8f8af09-efc3-4c31-a1fe-a258e03ba596",
          "b54150bc-ff5c-4a4e-89ed-e464738c8fe1",
          "ed428593-9b0d-4bfb-a0a3-bfdb1f07b867",
          "1078d1eb-8b26-43e6-8a7c-f50baace4493",
          "52b8d052-eb27-45ef-937b-4d805624e1d8",
          "7ba3c36e-fe1d-4a1c-b128-4ef28914e3b1",
          "ec674070-83a0-4b78-bba5-81e3181a98db",
          "737b5356-777d-43fc-a56a-932b9728eb72",
          "18fb448b-e1e3-4609-b2c8-4ddb03ffbaec",
          "f88b4e60-1b70-41e2-a093-ad6b56b0b2c7",
          "fd40467e-04cf-4de0-93b3-48769c0979b3",
          "7ba9c223-de24-4a6d-b3f9-565e1356adcf",
          "e4bd43f0-523e-4aca-b763-abd0d4452765",
          "f742e5ee-866c-4ecc-853b-5bb7a3aa8e0e",
          "e1d90790-67b0-4cf8-a1b0-adc93af5dd11",
          "5734f093-fe98-433c-8f55-381d77d2e914",
          "b1376447-ec2c-467f-bdf3-213ff8d87e88",
          "81293d49-5af5-4f63-9986-3f05286030a4",
          "0d0c3531-eb15-43b7-950b-4d638136c650",
          "58ab2b79-62cf-45ca-993c-51a301a1696f",
          "4d7772bb-b114-4f5d-8a59-7a10522f9edb",
          "66217eb7-4aec-4fed-b0b8-b7f204a4cdbf",
          "f9af4847-2f17-4b20-8e36-6a38e0e8858f",
          "f924b88d-68af-4408-bcb3-c172f281d11b",
          "0bd82c76-f93d-46ba-9387-7b82a21783fc",
          "f2c103a1-a8a9-49e4-933e-e0c770ac4b38",
          "32eb36ba-7fc1-498a-89bd-9a57e089ea28",
          "0404379c-9953-4bd2-a753-104cb6956a91",
          "1b4e9ca3-0273-4581-a9d9-51bf0f9ffe59",
          "e6f47dbb-c7fd-43c9-96d3-bcd518ac1028",
          "db5c2e6a-66b4-4540-8ed9-9b2c7e4b88cf",
          "5c826024-78c4-4043-822e-9faf5345cc08",
          "2921d3a0-fba7-4119-a08a-e07d58201bb0",
          "902d2b7b-479f-40b1-a588-d9c725b910c1",
          "f0621d7d-9441-4a0c-a063-cbcef9dd7e01",
          "ff63fbeb-db1c-4325-baca-3a8432dbe7b7",
          "37b133a1-e6ba-4808-987a-9a709354e4a3",
          "d9784db8-2699-4408-9d11-94dd8f4950e0",
          "509cf493-4e2c-464d-89f5-94aa8ff7536e",
          "1a2eef2f-29ea-4cb0-8c01-a0dccdc44ef3",
          "54e70fcf-a01e-4376-b219-dad1b054b42c",
          "4893ca9d-4138-439f-845a-2b50557b89f3",
          "675f37e4-97c0-4f88-912e-51ed0524ff67",
          "ea8b9ccf-12ec-494e-abfa-a9f5ed522dca",
          "c46eba6c-442d-4889-be80-948496820222",
          "2c6ad52d-e1b8-46ee-8930-a1f225ec4667",
          "697b2020-5b53-41ad-8833-10ca32041cc7",
          "d0c21492-395c-4ebc-906a-90aa3b4751df",
          "010f5e3b-71ed-404d-9dc7-661104068560",
          "9590a764-ff2d-40c2-a416-6a2b1927808e",
          "c8e5bac5-df1f-45b5-ba4e-50fff1161c14",
          "e0d026f0-88af-4b64-8358-c1cb103602ea",
          "3969900b-7498-45ae-a67b-a42fee1f3357",
          "c24e59ab-bd97-41f3-b931-8f67fd77ed20",
          "1e64147e-8248-4431-b987-6b43c0a87b72",
          "aceb2cf5-7241-45af-925f-33e038def041",
          "a9c7f4f1-ef9c-416a-9976-72e028628074",
          "32b9e151-ac03-405e-b1b7-3ac1593c64cc",
          "69868741-8916-44b5-987d-ff409346bbc6",
          "b3247b69-da29-4cfe-82f9-af09212d724f",
          "f381e3ab-d51d-4cd5-88e2-2fb251a767ea",
          "c04e9d48-f2e3-4667-b836-d76b09697fb1",
          "f87c6061-240b-4f33-afa5-730d71805c3d",
          "9d22302f-75d3-48e1-aad6-1449c30c6ba8",
          "c444739f-b439-42b8-8d1a-cec6de08badc",
          "2dbbaf98-0f34-479c-a150-be4f75a95a35",
          "e7908971-3a76-4188-93ef-fc2b10b17ab8",
          "6f15115f-c352-4f9f-a1e7-30be29367fec",
          "1268a0cf-cef2-43db-9ee7-61059ae1b579",
          "56867429-4f9c-4ac3-9612-d8e4690441a6",
          "de89a9c1-8153-4d3a-af6d-e7bd7005d3ec",
          "97a5be43-3467-4b19-8d92-25017702a5bf",
          "3d9893fc-fa09-4ac4-b178-e1099bce48f1",
          "e98ceedd-20ca-473b-b815-a2f448e79c99",
          "d73b8a97-5d86-4d97-950d-8f2ade1e6fdb",
          "ad3fb8bb-6881-4202-b779-903902490cb6",
          "f2f22c37-a687-49fc-9209-e7a141563b82",
          "d94a15c8-ad45-48c1-bbfa-ef5ca8f7f3c5",
          "e039c05e-1c0a-4b20-996c-c3438a77a698",
          "191efafd-5daa-47e3-9986-ff514b76af5a",
          "4c8e2409-a66a-448f-b250-dea76cad9813",
          "2da81d59-a62c-45a7-9f5f-28c1b92a9cfa",
          "99cc17e4-17d7-4109-becc-9064d032bd9b",
          "ccb7da28-a7dc-4d17-afca-538b5a2623d6",
          "628e6fe9-4f67-4866-898f-e56e256b28d6",
          "e719cb38-b7e2-4ba4-9fcf-d6fe507d6ce4",
          "dd7593a7-d618-429a-b464-025e2535c248",
          "948511ec-2a1e-45c1-b976-a3cce9f2c9f3",
          "f25435e8-e6d0-456b-b53b-9237583d123f",
          "a5a42a36-9673-460c-a631-09568882c623",
          "b23f3713-d931-41dc-a567-d0138d9850f7",
          "091e0440-66fc-4d43-bfe9-51907161c358",
          "0e266e0f-2742-4ea8-bab1-53562cd2e646",
          "73efe58a-f8df-40e1-8de4-4168f9405396",
          "c6a57cd4-939e-4224-83e1-af06919cb38a",
          "d205c91e-06a8-472b-9b4c-35a33447c921",
          "ed2de9b0-374d-4534-8f19-2b77966e7faa",
          "fabbf97f-2343-4fa8-bb95-8575e1419068",
          "00576fde-8cf6-435d-b650-7aaff37a1806",
          "6f49fdbb-ad9f-4d7a-ae40-2f1a61c2c947",
          "ef2ef2c5-8c56-4c57-a84e-3b173231456f",
          "0924deaa-c9e0-43d1-9629-284bcabb556d",
          "1009d3b1-ab5c-419e-8ed7-427c6d66e08a",
          "af2dc40d-9bff-4941-b487-21efcd512176",
          "e25036e0-9f23-407e-aacd-b3cb14a13b90",
          "b550c9dd-ea05-4b09-8c88-47f071239f59",
          "8d750507-de52-41f2-b88a-b001c12cf008",
          "0989a337-8e20-4704-b727-a45c44c2a9f3",
          "2b114170-0532-4a0a-90e6-ae6a8f652b0d",
          "e90db5e6-004f-44c9-a10c-f1f8546f78c1",
          "5ac8d604-b11c-4106-b3df-f2bcc32f8c1a",
          "577eb8b3-4785-4de3-8873-458c81bedea6",
          "95efcd76-f7d7-45b2-b2cd-fc26b6a370a7",
          "a8121f0b-fcce-4b32-98f1-83b7cca5f5d5",
          "1b1cd8ef-34cc-4abd-8bfc-bc00150c7424",
          "abc72c86-8f45-43ed-9391-2b139ade85a8",
          "af84ab2d-5d17-4aee-9026-0ec1cf7d7d2b",
          "1d1b4acd-fd8e-4851-8646-6f7b6f123973",
          "23f6546f-4be5-47bd-b8df-694da76df679",
          "2c0a4a78-54fd-4720-b9b4-463b13219f9c",
          "41bc93a6-1d29-4ccb-b19a-9999803dc362",
          "557bcfed-813f-4a17-8a03-211b1b70b54c",
          "8005f64c-caea-49a4-a364-fca20bf1accc",
          "dced02da-69f6-4d32-acb5-2eee7ef49cea",
          "89b36584-9baa-4914-aa87-6f31234b12f4",
          "674c6625-4d24-4fe1-bf83-fdd629ac6d21",
          "c6f162c4-eb1f-4a48-a679-6ba9ae87c39c",
          "e98c5484-9e29-4415-b26b-94735b38e475",
          "422261f3-ea62-44a7-a557-e5ed777738b7",
          "b597f31d-6a42-44de-92e2-d465b0022aa6",
          "6ca5c575-7f7e-4a28-b913-3da0cb33d8ae",
          "648f6f0b-dd90-4a1c-8d62-fa8e0cc5f1b0",
          "4ffeefce-78fd-4624-b2f4-682709bd77cc",
          "e2d203c9-1b3b-4f9c-9b94-0e0fefb53642",
          "36b4ac54-08d6-4c41-8a8d-02ef8e554c8e",
          "1dd8a169-83d4-401b-966f-1912160d7760",
          "6739355f-a991-4631-b03d-54051513cb1f",
          "7a389de3-093c-49c5-99a4-83008ed6584e",
          "fc9a0b7c-a314-462c-8215-35885a399dc4",
          "b06a9af6-6718-49a3-8e57-9d5ce1578b59",
          "1a3c2eda-e41d-4ceb-8f56-cc50da8c117e",
          "c1258e5f-ce0f-4285-8cca-15ea685ab432",
          "2b9c301c-7eb6-4af7-a60c-b52aa088adea",
          "5c59e570-80fb-4a90-8c43-00733f977ec6",
          "b1d4ffa6-36c6-4e8e-a90d-220c526ee61b",
          "55903b10-e7da-4d62-b274-02c9818868ea",
          "8341e3bc-9f2f-4fef-910a-284f63611735",
          "4ea0321a-a184-4484-9210-3e3dab854b3d",
          "a2f3e53c-aef6-4f8e-8d1c-b9dfd514ef09",
          "21ea68c9-7c02-43bf-b4b6-6cab2e1c5d06",
          "ffca3e33-de1d-441c-adc6-c8fa4821205f",
          "0e95f35f-bcb2-4de0-ad57-2f78df301a0d",
          "aefb5185-9120-4db5-98cb-3cfebc27a83a",
          "ed985296-985f-41df-ab30-574fe1cab224",
          "3b1a3f86-41e4-4d86-8c09-c63ae9dc8fe2",
          "d59fb1c9-44a4-4f65-b7b2-d2397e0e0fe8",
          "bedaf646-f410-4def-aa44-5ef24d0af7e0",
          "f809a8fa-6763-4b2b-90d4-99f5caea7c4d",
          "f77e38cd-fab4-450e-9588-732bba747e4c",
          "2257611b-245b-4765-ab8e-77f502468cf2",
          "988b63d4-7156-458e-8df3-a37567461aff",
          "4dd96419-db13-49f0-8f52-754ab00192f8",
          "6c4632ed-6148-4812-a77a-88a2bda3c51c",
          "35efdc23-b8e2-4257-805b-62b570090f4f",
          "ff189291-abd3-4a19-a936-8edfbf2fc71e",
          "ebe3785c-2511-472c-9bbe-e666e3ff4165",
          "b070e069-5c44-4f21-ad09-498ea565d33b",
          "0915aac6-2696-4c21-a73f-2903581e96bc",
          "6513c7da-3894-4c92-ba89-bf75834c1b21",
          "63fff20d-a022-42b9-8c16-bfec89f01384",
          "c33690f2-0813-4a47-80f3-bc1fc453cb67",
          "384945ff-bca6-4ca0-948c-6168ceefda51",
          "686e307f-e890-4567-8c1c-b945bdfd80f5",
          "854f7ce6-3090-466c-ae10-9fdf2a4bd70f",
          "eadcd83a-60b4-4f92-ade4-c5d6927012e1",
          "bbd3ab16-680b-4614-8e42-570fcc6ac9a5",
          "30011ed2-bede-4858-b98f-1c8a55dba635",
          "8bdbc4f1-b671-4983-a8bc-946dbd219ef5",
          "eede2fd2-b713-4da3-ba2f-f32574655c88",
          "ddcc589c-3fad-45c1-8622-7d979549a5da",
          "96b3a773-820b-4779-b812-6dd88b05b673",
          "db51907a-e243-4d79-ab61-602425ac64b3",
        ];
        uids.map((v, i) => {
          this.setState((prevState) => ({
            values: {
              // Object that we want to update
              ...prevState.values, // Keep all other key-value pairs
              [v]: value, // Update the value of specific key
            },
            currentPageData: { ...prevState.currentPageData },
          }));
        });
        break;
      case "D-SP":
        uids = [
          "d742abf0-34cf-4c07-9133-2656503b848d",
          "b743e9ec-55f5-4b06-b70e-9f08b77350c8",
          "f7b97316-ceef-4585-85a9-15b0001fef79",
          "a07f4f45-a5fe-4b4b-b792-3d635ffc96cf",
          "04d61978-28a7-47be-9176-a17005adec19",
          "86301a0b-152a-46d8-a244-9a98d21a6c7a",
          "cdaa3646-53db-4ae4-81e3-e23e8058442b",
          "464b0d71-f6e0-4dbf-94c0-e00d427d61ba",
          "f768dc52-fe1b-4323-824c-bdd036e097ab",
          "cafa9075-4b2a-4275-97ee-3754b5f8405c",
          "4678fed8-63e6-4034-9ddf-8328ee39723d",
          "1c53e5dd-477e-41a4-bc53-faaa0766eda2",
          "699249cb-f9c4-4740-9ad4-bfcbcff91201",
          "1b20dee1-39f7-427b-8bb4-82d425fcdfe3",
          "8f5e2c2d-3dfd-4f02-a1f4-bf04df7c229c",
          "98933a66-cd0f-4567-98e6-7c0b77fd6c6c",
          "c6c9f11e-95f4-4d8e-a529-08ba12410ea0",
          "08fb6e01-4b0c-4a76-8a73-ac6fa1f825a5",
          "3d450785-a99a-4a85-93d3-5f4e5c41a78a",
          "ddfb1986-af32-4a94-a729-b0573b86c7ae",
          "1a99c4ce-c1ff-4799-a68d-1d4b2560dc67",
          "2b45c9c6-41fe-44cc-aa62-ef9bb8067781",
          "2ced54de-5b80-4f48-8f4b-4e4e72861154",
          "640e46ca-d2d5-4a17-9555-390ef9cdbe49",
          "e43637ef-202c-42f9-b11d-bbfb35f7b064",
          "101bec8b-e69c-4d83-850f-26ab9c73e428",
          "dee26b3c-b40b-4049-a59f-ee4fa8ce96d0",
          "cba3a8cd-1c4b-4c82-a3b0-cab2693b025a",
          "1a1bfa4b-5f0a-4534-bb00-13abb8f62b93",
          "8a7c019a-5b68-48c9-975f-7d2299ca9254",
          "e23446ac-19c4-400a-b0c2-4db5aabf4883",
          "ce60acb8-b929-4300-92c0-870cc42e9212",
          "6bba1b81-d646-4b99-9b48-be90fd1e5123",
          "884a2baa-c99e-4314-9197-34b8f13fb120",
          "fc9809f2-2e5e-4cbe-b030-f33c0f119b13",
          "bbcb5406-b3b0-44f2-bc67-f05e64ba8080",
          "4433a0e5-0224-44b7-8285-18dcf1eeebe0",
          "5571db8d-ccd8-4779-bdd2-e4c9258da06d",
          "acd7f775-1c7d-4dc0-8253-742e6a7cd084",
          "7897dd44-388e-4287-969a-c59e20b21924",
          "a2556df3-fcaa-427e-b2fe-1cffe848b5e9",
          "70c514ad-8e67-447e-9d77-930889c30b34",
          "3274ccb0-94d0-4c81-b133-a8665ec54018",
          "afb5ac2e-b50e-4264-9531-e1cba9e70354",
          "d4e24f44-1310-4709-9ab9-7b506fb9eed1",
          "730ef487-fba5-40fe-bc7c-32757df6cec5",
          "37c1a6f2-cdd3-43f6-84ab-e2a179880236",
          "790e50e6-2700-4388-8ef8-388ff2fe9968",
          "3624e755-7f5b-4760-a2d7-8875d78ef21e",
          "2be5d43f-dd2d-4a22-8339-5181e10f08f2",
          "01255226-2d0e-4d61-b643-da6fae01b447",
          "16045973-fa74-4dbc-a0bd-42f920c99822",
          "d2e64262-ae97-42e0-92d5-e7203e424f5f",
          "6ab01606-bedd-43e3-b4cd-3711019ad863",
          "efec269e-79d3-498f-8be7-f2c2e5df9ab1",
          "52db9fb9-0301-47df-abc7-a773925f46c9",
          "fac2bd95-202c-4b81-9634-7ce01d576d6f",
          "3e692a96-2164-468c-8550-dc54a00eb1e1",
          "431359de-d7fb-4f02-b72a-ab84bea002ab",
          "d6b563de-d276-44c8-a093-fb73a928dd9a",
          "01096367-35a8-4c6d-9ea6-a51b4772d7f2",
          "6977ca94-a321-42b6-a181-754e9842c3e9",
          "ac1fc75d-dccf-4988-9529-1f9836a0c53d",
          "e413cf69-a333-454e-abea-53e7de37dd1d",
          "6c6f9fff-7f23-4f0e-a3e7-4645436eff8d",
          "d12a8b31-4b5f-4407-b08b-4e4891f1c624",
          "a6415f4a-9381-437f-a828-73bd56184d39",
          "d28e1f71-f3e4-491f-ad1d-2df0501cf631",
          "634bb0b1-4ea5-4fb0-9c4f-bac730b5d22a",
          "143743ac-a356-44fc-8a5d-eab58a753860",
          "edc64438-0429-4499-abeb-6e19b94d1630",
          "f4d6e6de-8740-49b6-8890-1030b0d83094",
          "a049b982-8a08-4513-94b3-e02050ece2a8",
          "3114324c-32b1-444a-9e9f-a9cb2f644eb4",
          "8a2e8b27-ef43-460f-b9a0-e05e36109f82",
          "a8f8af09-efc3-4c31-a1fe-a258e03ba596",
          "b54150bc-ff5c-4a4e-89ed-e464738c8fe1",
          "ed428593-9b0d-4bfb-a0a3-bfdb1f07b867",
          "1078d1eb-8b26-43e6-8a7c-f50baace4493",
          "52b8d052-eb27-45ef-937b-4d805624e1d8",
          "7ba3c36e-fe1d-4a1c-b128-4ef28914e3b1",
          "ec674070-83a0-4b78-bba5-81e3181a98db",
          "737b5356-777d-43fc-a56a-932b9728eb72",
          "18fb448b-e1e3-4609-b2c8-4ddb03ffbaec",
          "f88b4e60-1b70-41e2-a093-ad6b56b0b2c7",
          "fd40467e-04cf-4de0-93b3-48769c0979b3",
          "7ba9c223-de24-4a6d-b3f9-565e1356adcf",
          "e4bd43f0-523e-4aca-b763-abd0d4452765",
          "f742e5ee-866c-4ecc-853b-5bb7a3aa8e0e",
          "e1d90790-67b0-4cf8-a1b0-adc93af5dd11",
          "5734f093-fe98-433c-8f55-381d77d2e914",
          "b1376447-ec2c-467f-bdf3-213ff8d87e88",
          "81293d49-5af5-4f63-9986-3f05286030a4",
          "0d0c3531-eb15-43b7-950b-4d638136c650",
          "58ab2b79-62cf-45ca-993c-51a301a1696f",
          "4d7772bb-b114-4f5d-8a59-7a10522f9edb",
          "66217eb7-4aec-4fed-b0b8-b7f204a4cdbf",
          "f9af4847-2f17-4b20-8e36-6a38e0e8858f",
          "f924b88d-68af-4408-bcb3-c172f281d11b",
          "0bd82c76-f93d-46ba-9387-7b82a21783fc",
          "f2c103a1-a8a9-49e4-933e-e0c770ac4b38",
          "32eb36ba-7fc1-498a-89bd-9a57e089ea28",
          "0404379c-9953-4bd2-a753-104cb6956a91",
          "1b4e9ca3-0273-4581-a9d9-51bf0f9ffe59",
          "ff63fbeb-db1c-4325-baca-3a8432dbe7b7",
          "37b133a1-e6ba-4808-987a-9a709354e4a3",
          "d9784db8-2699-4408-9d11-94dd8f4950e0",
          "509cf493-4e2c-464d-89f5-94aa8ff7536e",
          "1a2eef2f-29ea-4cb0-8c01-a0dccdc44ef3",
          "54e70fcf-a01e-4376-b219-dad1b054b42c",
          "4893ca9d-4138-439f-845a-2b50557b89f3",
          "675f37e4-97c0-4f88-912e-51ed0524ff67",
          "ea8b9ccf-12ec-494e-abfa-a9f5ed522dca",
          "c46eba6c-442d-4889-be80-948496820222",
          "2c6ad52d-e1b8-46ee-8930-a1f225ec4667",
          "697b2020-5b53-41ad-8833-10ca32041cc7",
          "d0c21492-395c-4ebc-906a-90aa3b4751df",
          "2257fd27-8db6-4339-8c97-69c29af0bcaa",
          "010f5e3b-71ed-404d-9dc7-661104068560",
          "9590a764-ff2d-40c2-a416-6a2b1927808e",
          "c8e5bac5-df1f-45b5-ba4e-50fff1161c14",
          "e0d026f0-88af-4b64-8358-c1cb103602ea",
          "3969900b-7498-45ae-a67b-a42fee1f3357",
          "c24e59ab-bd97-41f3-b931-8f67fd77ed20",
          "1e64147e-8248-4431-b987-6b43c0a87b72",
          "aceb2cf5-7241-45af-925f-33e038def041",
          "a9c7f4f1-ef9c-416a-9976-72e028628074",
          "32b9e151-ac03-405e-b1b7-3ac1593c64cc",
          "69868741-8916-44b5-987d-ff409346bbc6",
          "b3247b69-da29-4cfe-82f9-af09212d724f",
          "f381e3ab-d51d-4cd5-88e2-2fb251a767ea",
          "c04e9d48-f2e3-4667-b836-d76b09697fb1",
          "1b4e7fc9-5e5f-4b2a-a134-c483220fcb06",
          "529f0f67-f13d-4682-b1ec-e13f7959f7a8",
          "f87c6061-240b-4f33-afa5-730d71805c3d",
          "9d22302f-75d3-48e1-aad6-1449c30c6ba8",
          "c444739f-b439-42b8-8d1a-cec6de08badc",
          "2dbbaf98-0f34-479c-a150-be4f75a95a35",
          "e7908971-3a76-4188-93ef-fc2b10b17ab8",
          "6f15115f-c352-4f9f-a1e7-30be29367fec",
          "1268a0cf-cef2-43db-9ee7-61059ae1b579",
          "56867429-4f9c-4ac3-9612-d8e4690441a6",
          "de89a9c1-8153-4d3a-af6d-e7bd7005d3ec",
          "97a5be43-3467-4b19-8d92-25017702a5bf",
          "3d9893fc-fa09-4ac4-b178-e1099bce48f1",
          "e98ceedd-20ca-473b-b815-a2f448e79c99",
          "d73b8a97-5d86-4d97-950d-8f2ade1e6fdb",
          "46957af4-6d29-41a4-9bf7-47374aae4c29",
          "9991a41c-cbd5-4742-8c73-0646766555d6",
          "4a5b342b-1b69-4317-a74c-3623fe5a584a",
          "7e9a2d52-5749-4939-a045-079bba59f45c",
          "d8a51309-65db-458f-8819-cc912552a373",
          "60387821-4dd3-4fa6-875a-41a4aa702f0c",
          "4d2c1e51-381b-46cf-b4bb-3ffe3aec6360",
          "99cc17e4-17d7-4109-becc-9064d032bd9b",
          "ccb7da28-a7dc-4d17-afca-538b5a2623d6",
          "628e6fe9-4f67-4866-898f-e56e256b28d6",
          "e719cb38-b7e2-4ba4-9fcf-d6fe507d6ce4",
          "dd7593a7-d618-429a-b464-025e2535c248",
          "948511ec-2a1e-45c1-b976-a3cce9f2c9f3",
          "f25435e8-e6d0-456b-b53b-9237583d123f",
          "f654f7e4-50b9-4edb-8818-484b0c79b4d8",
          "b23f3713-d931-41dc-a567-d0138d9850f7",
          "5e912eef-110c-4111-9c4e-c21969990c38",
          "d5e7330b-fb7f-4d9b-be6b-c70b7bfe6bbc",
          "6f7579e9-3e43-46c7-a6be-49777d14cb35",
          "f6196dcd-0cf7-419a-ad70-7dc192a05e8a",
          "02e2f4b6-525f-47eb-b91c-503070dc508c",
          "1d98c191-08c6-4443-bc75-1c11bc6dbb62",
          "fabbf97f-2343-4fa8-bb95-8575e1419068",
          "00576fde-8cf6-435d-b650-7aaff37a1806",
          "6f49fdbb-ad9f-4d7a-ae40-2f1a61c2c947",
          "ef2ef2c5-8c56-4c57-a84e-3b173231456f",
          "0924deaa-c9e0-43d1-9629-284bcabb556d",
          "1009d3b1-ab5c-419e-8ed7-427c6d66e08a",
          "af2dc40d-9bff-4941-b487-21efcd512176",
          "e25036e0-9f23-407e-aacd-b3cb14a13b90",
          "b550c9dd-ea05-4b09-8c88-47f071239f59",
          "8d750507-de52-41f2-b88a-b001c12cf008",
          "0989a337-8e20-4704-b727-a45c44c2a9f3",
          "2b114170-0532-4a0a-90e6-ae6a8f652b0d",
          "e90db5e6-004f-44c9-a10c-f1f8546f78c1",
          "5ac8d604-b11c-4106-b3df-f2bcc32f8c1a",
          "577eb8b3-4785-4de3-8873-458c81bedea6",
          "95efcd76-f7d7-45b2-b2cd-fc26b6a370a7",
          "a8121f0b-fcce-4b32-98f1-83b7cca5f5d5",
          "1b1cd8ef-34cc-4abd-8bfc-bc00150c7424",
          "abc72c86-8f45-43ed-9391-2b139ade85a8",
          "af84ab2d-5d17-4aee-9026-0ec1cf7d7d2b",
          "1d1b4acd-fd8e-4851-8646-6f7b6f123973",
          "23f6546f-4be5-47bd-b8df-694da76df679",
          "2c0a4a78-54fd-4720-b9b4-463b13219f9c",
          "41bc93a6-1d29-4ccb-b19a-9999803dc362",
          "29edb869-9748-4a0c-a0e8-572074255196",
          "557bcfed-813f-4a17-8a03-211b1b70b54c",
          "8005f64c-caea-49a4-a364-fca20bf1accc",
          "dced02da-69f6-4d32-acb5-2eee7ef49cea",
          "89b36584-9baa-4914-aa87-6f31234b12f4",
          "674c6625-4d24-4fe1-bf83-fdd629ac6d21",
          "c6f162c4-eb1f-4a48-a679-6ba9ae87c39c",
          "e98c5484-9e29-4415-b26b-94735b38e475",
          "73eabfac-f319-4c98-9057-1468a0f631fe",
          "2dab926f-e888-4b88-9c0e-b9772ba0805c",
          "d08e1aeb-247f-4d92-a499-165faef228e6",
          "8d32be7e-7b9c-4ac5-962e-80eb81ae3b6f",
          "5e025536-e18f-4ec7-b57e-89d61c6610f0",
          "e2d203c9-1b3b-4f9c-9b94-0e0fefb53642",
          "36b4ac54-08d6-4c41-8a8d-02ef8e554c8e",
          "1dd8a169-83d4-401b-966f-1912160d7760",
          "6739355f-a991-4631-b03d-54051513cb1f",
          "7a389de3-093c-49c5-99a4-83008ed6584e",
          "fc9a0b7c-a314-462c-8215-35885a399dc4",
          "b06a9af6-6718-49a3-8e57-9d5ce1578b59",
          "0876203e-6ab2-43ee-8cf4-d65b3e266fc6",
          "a1632514-bf6a-405c-bb3b-942e3fae7206",
          "1a3c2eda-e41d-4ceb-8f56-cc50da8c117e",
          "49b4434c-61fd-403a-ad1b-23935e8d0981",
          "c1258e5f-ce0f-4285-8cca-15ea685ab432",
          "2b9c301c-7eb6-4af7-a60c-b52aa088adea",
          "5c59e570-80fb-4a90-8c43-00733f977ec6",
          "b1d4ffa6-36c6-4e8e-a90d-220c526ee61b",
          "55903b10-e7da-4d62-b274-02c9818868ea",
          "8341e3bc-9f2f-4fef-910a-284f63611735",
          "4ea0321a-a184-4484-9210-3e3dab854b3d",
          "a2f3e53c-aef6-4f8e-8d1c-b9dfd514ef09",
          "21ea68c9-7c02-43bf-b4b6-6cab2e1c5d06",
          "ffca3e33-de1d-441c-adc6-c8fa4821205f",
          "0e95f35f-bcb2-4de0-ad57-2f78df301a0d",
          "aefb5185-9120-4db5-98cb-3cfebc27a83a",
          "2e292cad-df19-422f-9a9d-ee1e42f62e2e",
          "fd46606f-cf26-4f3c-b2c8-125bd2c3756a",
          "dc44de87-ac4a-42f0-98b9-938626b30c75",
          "ed985296-985f-41df-ab30-574fe1cab224",
          "856a8d5e-81a4-480f-8a54-b8d0c99afd92",
          "9a830856-4384-4e5c-92b5-932e7818661a",
          "d9b46ce2-ee08-4ed4-81f1-4e182fcf08ea",
          "8763592d-8a00-4b72-9aea-a3225619bd51",
          "b969fc3b-efbd-43da-83ec-229ebec09fde",
          "fc65a2e3-f213-4bf8-8cb1-5b6708905704",
          "85d2e403-7575-40d2-af51-a36e3f13278a",
          "c3c530da-bf4f-4b4e-b9c4-e6e5ff08435e",
          "ed1dc504-ad0d-4628-ba94-c515a0b1042c",
          "6ef603ee-17bf-445c-a481-f16207db6a71",
          "e28d8cc0-65c6-4cc2-8085-1ced026d60e9",
          "6c4632ed-6148-4812-a77a-88a2bda3c51c",
          "35efdc23-b8e2-4257-805b-62b570090f4f",
          "ff189291-abd3-4a19-a936-8edfbf2fc71e",
          "ebe3785c-2511-472c-9bbe-e666e3ff4165",
          "6c70dbdf-3cf9-412c-a08d-3ed6542f7156",
          "7c3a0109-05a0-41ec-8d18-337dc862da41",
          "6513c7da-3894-4c92-ba89-bf75834c1b21",
          "63fff20d-a022-42b9-8c16-bfec89f01384",
          "c33690f2-0813-4a47-80f3-bc1fc453cb67",
          "384945ff-bca6-4ca0-948c-6168ceefda51",
          "686e307f-e890-4567-8c1c-b945bdfd80f5",
          "52753050-9d1c-4845-94c4-d037feeb6285",
          "d30fe39b-1adb-4981-848b-a21633c391ee",
          "854f7ce6-3090-466c-ae10-9fdf2a4bd70f",
          "eadcd83a-60b4-4f92-ade4-c5d6927012e1",
          "bbd3ab16-680b-4614-8e42-570fcc6ac9a5",
          "30011ed2-bede-4858-b98f-1c8a55dba635",
          "16af4c79-e20c-4cc6-b6b1-e66dd5473a70",
          "382cb4bd-7f91-4df7-b150-69b4e7398339",
          "b45b2437-8952-4e62-a386-e5e51318a7cd",
          "96b3a773-820b-4779-b812-6dd88b05b673",
          "71e5ff41-24b4-423a-94c8-316e96fd0e7f",
          "7a9fa34a-5cfc-4dbb-9513-48da1fddb4da",
          "04d882e3-f7af-4691-a406-60300159ecf3",
          "3431e8da-057b-4f0f-b8d1-3308c69dee49",
          "6855b70d-3612-480d-aaeb-3d9e6a514303",
          "10358195-7594-4c6c-94f7-af79539728dd",
          "e67f9411-180f-4a86-b9f3-d58965fe27ee",
          "b75016ef-64f7-4791-997e-534b3b7fc9b2",
          "f9835668-177d-4e5d-8335-43d759ddbefa",
          "5bec3e26-587f-4e73-8a8b-6aa0ca2feec7",
        ];
        uids.map((v, i) => {
          this.setState((prevState) => ({
            values: {
              // Object that we want to update
              ...prevState.values, // Keep all other key-value pairs
              [v]: value, // Update the value of specific key
            },
            currentPageData: { ...prevState.currentPageData },
          }));
        });
        break;
      default:
        break;
    }
  };

  navigatePages = (direction) => async () => {
    // document.getElementById("btnSpinner").click();
    this.setState(
      {
        processing: "yes",
      },
      () => {
        setTimeout(
          () => (
            this.setState({
              processing: "no",
            }),
            this.processStepChange(direction)
          ),
          250
        );
      }
    );

    // this.processStepChange(direction);
  };

  processStepChange = (direction) => {
    this.onClickSaveSaqData("draft");

    /// document.getElementById("btnCloseSpinner").click();
    let page = direction === "next" ? this.state.page + 1 : this.state.page - 1;

    this.setState(
      {
        page: page,
        lastPageVisited:
          page > this.state.lastPageVisited ? page : this.state.lastPageVisited,
      },
      () => {
        this.updateCurrentPage(page);
      }
    );
  };

  onClickSaveSaqData = async (status) => {
    const userLsData = authUserData();

    let userBusinessId =
      userLsData.businessDetails &&
      userLsData.businessDetails.length > 0 &&
      userLsData.businessDetails[0].businessId;

    /* console.log("onClickSaveSaqData userLsData", userLsData);
    console.log("userBusinessId", userBusinessId); */

    const payload = {
      subdomain: this.state.subdomain,
      saqId: this.props.saqId ? this.props.saqId : this.state.saqId,
      userId: userLsData.userId,
      businessId: userBusinessId,
      type: this.props.type,
      status: status,
      domain: this.state.values["7e6768ef-c046-4d39-82d0-6bdc6af3f79d"],
      lastPageVisited:
        this.state.page > this.lastPageVisited
          ? this.state.page
          : this.state.lastPageVisited,
      saqAnswers: this.state.values,
      history: this.props.history,
    };
    /* console.log(userBusinessId);
    console.log(typeof userBusinessId);

    console.log("payload", payload); */

    this.props.onClickSaveSaqData(payload);
  };

  handlePageClick = (data) => {
    //console.log("data", data);

    this.setState(
      {
        page: data.selected,
      },
      () => {
        this.updateCurrentPage(this.state.page);
      }
    );
  };

  toggleSimplifedData = () => {
    this.setState({
      showSimplifiedOptions: !this.state.showSimplifiedOptions,
    });
  };

  render() {
    const { type, formDataSaq } = this.props;
    const {
      page,
      currentPageData,
      values,
      totalPages,
      lastPageVisited,
      showSimplifiedOptions,
      showTitle,
      processing,
    } = this.state;

    return (
      <Fragment>
        <div className="cell small-12 medium-10" id="maincontent">
          <Header />

          <ToastContainer />

          <div id="body-content">
            <div className="grid-x grid-margin-x grid-margin-y">
              <div className="cell small-12 medium-12" id="saqform">
                <h3>CREATE NEW SAQ - {type}</h3>
                <h4 className="mt-4">
                  <b>
                    {currentPageData &&
                      ((showTitle === true &&
                        currentPageData.hasOwnProperty("title") &&
                        currentPageData.title) ||
                        "")}
                  </b>
                </h4>
                <h6
                  className="mt-4"
                  style={{ marginBottom: "0 px", fontSize: "20px" }}
                >
                  <b>
                    {currentPageData &&
                      ((showSimplifiedOptions === true &&
                        currentPageData.hasOwnProperty("simplifiedLabel") &&
                        currentPageData.simplifiedLabel) ||
                        (currentPageData.hasOwnProperty("label") &&
                          currentPageData.label))}
                  </b>
                </h6>
                {(showSimplifiedOptions === true &&
                  currentPageData &&
                  currentPageData.hasOwnProperty("simplifiedCaption") &&
                  currentPageData.simplifiedCaption &&
                  ((Array.isArray(currentPageData.simplifiedCaption) &&
                    currentPageData.simplifiedCaption.map((v) => {
                      return (
                        <p style={{ lineHeight: "20px" }}>
                          <small>
                            <strong>{v}</strong>
                          </small>
                        </p>
                      );
                    })) || (
                    <p style={{ lineHeight: "20px" }}>
                      <strong>
                        {currentPageData && currentPageData.simplifiedCaption}
                      </strong>
                    </p>
                  ))) ||
                  (currentPageData &&
                    currentPageData.hasOwnProperty("caption") &&
                    Array.isArray(currentPageData.caption) &&
                    currentPageData.caption.map((v) => {
                      return (
                        <p>
                          <strong>{v}</strong>
                        </p>
                      );
                    })) || (
                    <p>
                      <small>
                        <strong>
                          {currentPageData && currentPageData.caption}
                        </strong>
                      </small>
                    </p>
                  )}

                {showSimplifiedOptions === true &&
                  currentPageData &&
                  currentPageData.hasOwnProperty("simplifiedNotes") &&
                  currentPageData.simplifiedNotes && (
                    <p
                      style={{
                        marginTop: "-15px",
                        fontSize: "18px",
                        lineHeight: "21px",
                      }}
                    >
                      <small>
                        {currentPageData && currentPageData.simplifiedNotes}
                      </small>
                    </p>
                  )}

                <div className="cell-container">
                  <div className="grid-container">
                    <div className="grid-x grid-padding-x">
                      {(() => {
                        switch (
                          currentPageData && currentPageData.layout
                            ? currentPageData.layout
                            : ""
                        ) {
                          case "form":
                            return currentPageData.fields
                              .filter(this.fieldMeetsCondition(values))
                              .map((field) => {
                                switch (field.component) {
                                  case "checkbox":
                                    return (
                                      <Checkbox
                                        key={field._uid}
                                        field={field}
                                        handleFieldChanged={
                                          this.handleFieldChanged
                                        }
                                        value={values[field._uid]}
                                        showSimplifiedOptions={
                                          showSimplifiedOptions
                                        }
                                      />
                                    );
                                  case "radio":
                                    return (
                                      <Radio
                                        key={field._uid}
                                        field={field}
                                        handleFieldChanged={
                                          this.handleFieldChanged
                                        }
                                        value={values[field._uid]}
                                        showSimplifiedOptions={
                                          showSimplifiedOptions
                                        }
                                      />
                                    );
                                  case "table":
                                    return (
                                      <TableFields
                                        key={field._uid}
                                        field={field}
                                        handleFieldChanged={
                                          this.handleFieldChanged
                                        }
                                        values={values}
                                        showSimplifiedOptions={
                                          showSimplifiedOptions
                                        }
                                        handlePrefillOptions={
                                          this.handlePrefillOptions
                                        }
                                        type={type}
                                      />
                                    );
                                  case "label":
                                    return (
                                      <Label key={field._uid} field={field} />
                                    );
                                  default:
                                    return (
                                      <Field
                                        key={field._uid}
                                        field={field}
                                        handleFieldChanged={
                                          this.handleFieldChanged
                                        }
                                        value={values[field._uid]}
                                        showSimplifiedOptions={
                                          showSimplifiedOptions
                                        }
                                      />
                                    );
                                }
                              });
                          default:
                            return null;
                        }
                      })()}
                    </div>

                    {lastPageVisited !== 0 && (
                      <nav aria-label="Pagination">
                        <ReactPaginate
                          breakLabel={"..."}
                          breakClassName={"break-me"}
                          pageCount={lastPageVisited && lastPageVisited + 1}
                          marginPagesDisplayed={4}
                          pageRangeDisplayed={9}
                          containerClassName={"pagination"}
                          activeLinkClassName={"current"}
                          pageLinkClassName={""}
                          previousLinkClassName={""}
                          nextLinkClassName={""}
                          activeClassName={"current"}
                          pageClassName={""}
                          forcePage={page}
                          onPageChange={this.handlePageClick}
                        />
                      </nav>
                    )}

                    <div id="navbuttons">
                      <button
                        className={page > 0 ? "button prev-btn" : "button"}
                        disabled={
                          (processing === "yes" && true) || page > 0
                            ? false
                            : "disabled"
                        }
                        onClick={this.navigatePages("prev")}
                      >
                        Previous
                      </button>
                      {page < totalPages - 1 ? (
                        <button
                          className="button nxt-btn"
                          onClick={this.navigatePages("next")}
                          disabled={(processing === "yes" && true) || false}
                        >
                          {(processing === "no" && "SAVE AND CONTINUE") || (
                            <>
                              <img src={loading} width={"20px"} /> PROCESSING
                            </>
                          )}
                        </button>
                      ) : (
                        <button
                          className="button nxt-btn"
                          onClick={() => this.onClickSaveSaqData("completed")}
                        >
                          SAVE
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  saqData: state.saqStore.saq,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onClickSaveSaqData,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ComponentSaq)
);
